import Modal from './modal.js';

$(document).ready(function() {

	//check that user has added at least one guest before form submit
	$( "#create-visit-form" ).submit(function( event ) {

		var guestsLen = $('.guest').length;

		if(guestsLen < 1){
			event.preventDefault();
			alert("Please add at least one guest.");
		}

	  
	});

	var originalPassVals = {
		init 	: 	$('.pass-number-field').attr('data-color-init'),
		color 	: 	$('.pass-number-field').css('color')
	}

	$('select#visit-type').on('change',function() {
		if($(this).val() == 2) {
			$('#couriers').show();
			$('.pass-number-field').attr('data-color-init','W').css('color','white');

		} else {
			$('#couriers').hide();
			$('.pass-number-field').attr('data-color-init',originalPassVals.init).css('color',originalPassVals.color);
		}


	});

	$('select#visit-type').trigger('change');


	//var guestCounter = ($('.guest').length + 1);
	var guestCounter = $('.guest').length;

	$('.add-guest').click(function(e){
		e.preventDefault()

		addGuest();
	});
	
	function addGuest(){
		var html = createGuestHtml();		
		$('.guests').append(html);

		//increment each time - even if one is removed ids wont overlap
		guestCounter++;
	}

	function createGuestHtml(){
		var html = `
			<div class="row guest" id="guest_`+ getGuestCount() +`">
					
				<div class="item">
					<p class="heading">
						First Name<span class="required-field">&#42;</span>
					</p>
					
				</div>

				<div class="item">
					 <input class="guest-first-name" name="guest[`+ getGuestCount() +`][first_name]" value="" required>
				</div>

				<div class="item">
					<p class="heading">
						Surname<span class="required-field">&#42;</span>
					</p>
				</div>

				<div class="item">
					 <input class="guest-surname" name="guest[`+ getGuestCount() +`][surname]" value="" required>
				</div>
				
				<div class="item">
					<p class="heading">
						Company
					</p>
				</div>

				<div class="item">
					 <input class="guest-company" name="guest[`+ getGuestCount() +`][company]" value="">
				</div>
					
				<div class="item">
					<p class="heading">
					Contact Number
					</p>
				</div>
				
				<div class="item">
					 <input class="guest-contact" name="guest[`+ getGuestCount() +`][contact_number]" value="">
				</div>		        
			    
				
				<div class="item">
				</div>
				
				<div class="item visit-user-links">
					<a href="" class="remove-guest">Remove Passenger</a>
				</div>
			

				<input class="guest-user-id" type="hidden" name="guest[`+ getGuestCount() +`][user_id]" value="">

			</div>`;
		return html;
	}

	//taken out for the moment - when the mobile app is used will bring it back in, at the moment the sign in method is hardcoded as group sign in  - in VisitRepository
	// <div class="item">
	// 				<p class="heading">
	// 				Sign In method<span class="required-field">&#42;</span>
	// 				</p>
	// 			</div>

	// 			<div class="item">` + getSignInOptionsHtml() + `
	// 			</div>	

	function getSignInOptionsHtml(){
		var html = '<div class="select-with-dropdown"><select class="form-control" name="guest['+ getGuestCount() +'][sign_in_method]" required>';
		//get the options
		html += $('#sign-in-method').html();
		html += '</select></div>';
		return html;
	}
	

	//get the correct guest row and set hidden field with val and open modal
	$(document).on('click', '.link-to-user', function(e) {
		e.preventDefault();

        Modal.openModal('.modal-link-guest');

		setGuestBoxId($(this));
	 });

	$(document).on('click', '.remove-guest', function(e) {
		e.preventDefault();

        var parent = getParent($(this));

		//remove parent - check if existing guest - set in deleted id array
		var hiddenIdEl = parent.find('.guest-id');

        //check if this has id ( i.e. exists in database )
        if (hiddenIdEl.length) {
            //pass id through to server

            var guestId = hiddenIdEl.val();

            //add offer id to hidden fields
            var inputHtml = '<input type="hidden" name="deletedGuests[]" value="'+ guestId +'">';
            $('.deletedGuests').append(inputHtml);

        }
		parent.remove();
	});

	//confirm delete
	$(document).on('click', '.delete-visit', function(e) {
		e.preventDefault();

        Modal.openModal('.modal-remove-visit');

	});


	


	function getParent(self){
		return self.parent('.item').parent('.guest');
	}

	function getGuestCount(){
        return guestCounter;
    }

    function fillGuestData(response, isUser){
    	var parentGuestBox = getParentGuestBox();

    	parentGuestBox.find('.guest-first-name').val(response.first_name);
    	parentGuestBox.find('.guest-surname').val(response.surname);
    	parentGuestBox.find('.guest-company').val(response.company);
    	parentGuestBox.find('.guest-email').val(response.email);
    	parentGuestBox.find('.guest-contact').val(response.contact_number);

    	//if theyve used a user to popualate details - dont want to use VisitGuest id
    	if(isUser){
    		parentGuestBox.find('.guest-user-id').val(response.id);
    	}
    	
    }

	$( ".guest-select" ).change(function() {

	  var optionSelected = $('option:selected', this);
	  var guestId = optionSelected.val();

	  if(optionSelected.hasClass('guest-option')){
	  	//is user - get details
	  	getVisitGuestDetails(guestId);
	  }else{
	  	//is user - get details
	  	getUserDetails(guestId);
	  }

	  

	});

	function getVisitGuestDetails(guestId){
		$.ajax({
          url: window.site.url + '/api/guest-details',
          method: 'GET',
          data: {
            id: guestId
          },
          success: function( response ) {
             //response is html
             fillGuestData(response,false);
          }
      });
	}

	function getUserDetails(userId){
		$.ajax({
          url: window.site.url + '/api/user',
          method: 'GET',
          data: {
            id: userId
          },
          success: function( response ) {
             //response is html
             fillGuestData(response,true);
          }
      });
	}

	function getParentGuestBox(){
		return $("#" +$('#guestBoxId').val());
	}

	function setGuestBoxId(self){
		var parentId = getParent(self).attr('id');
		$('#guestBoxId').val(parentId);
	}

	$(document).on('click', '.create-user', function(e) {
		e.preventDefault();

        Modal.openModal('.modal-create-user');
        var self = $(this);
		setGuestBoxId(self);

		//set create user modal values if set
		setModalInputValues(self);

	});

	function setModalInputValues(self){
		var parent = getParent(self);
		var firstName = parent.find('.guest-first-name').val();
		var surname = parent.find('.guest-surname').val();
		var email = parent.find('.guest-email').val();
		var company = parent.find('.guest-company').val();
		
		$('#user-form-first-name').val(firstName);
		$('#user-form-surname').val(surname);
		$('#user-form-email').val(email);
		$('#user-form-company').val(company);
	}
	

	$(document).on('click', '#create-user-button', function(e) {
		e.preventDefault();

		//get form fields

		var data = {
			email : $('#user-form-email').val(),
			first_name : $('#user-form-first-name').val(),
			surname : $('#user-form-surname').val(),
			company : 'fk',
			company_id : $('.user-modal-select').val(),
			password : $('#user-form-password').val(),
			contact_number: $('#user-form-contact-number').val(),
			password_confirmation : $('#user-form-password-confirm').val(),
			_token: window.site.token
		};

		$.ajax({
          url: window.site.url + '/user/create/ajax',
          method: 'POST',
          data: data,
          success: function( response ) {
             //response is html
             Modal.closeModal();
             fillGuestData(response, true);
          },
          error: function(jqXHR,textStatus, errorThrown ){
          	var responseText = $.parseJSON(jqXHR.responseText);
          	var html = createErrorMessage(responseText);
          	$('.user-create-errors').html(html);
          }
      });

	});

	function createErrorMessage(response){
		$.each(response, function(index, value) {
			$('input[name="'+index+'"]').parent().addClass('input-error');
			if(index == 'password') {
                $('input[name="password_confirmation"]').parent().addClass('input-error');
                $('input[name="password_confirmation"]').next().closest('span').text(value[0]);
            }
            $('input[name="'+index+'"]').next().closest('span').text(value[0]);
		});
	}

	$('.create-visit-btn').click( function() {
		$('#create-visit-form').submit();
	});

    $('.filter-visits-btn').click(function() {
    	Modal.openModal('.filter-modal');
    });

    $('.link-to-user-select').change( function(){
		Modal.closeModal();
	});


});


// WEBPACK FOOTER //
// ./visit.js